import { TertiaryButton } from 'src/presentation/components/molecules/Button';
import { Text, View, StyleSheet } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';

type Props = {
	url?: string | null;
};

function ReservationPreferenceCta({ url }: Props) {
	const { confirmLeaving } = useLeaveAppStore();

	const openInBrowser = (targetUrl: string) => confirmLeaving({ url: targetUrl });

	return url ? (
		<View style={styles.addPreferencesContainer}>
			<Text style={styles.addPreferencesHeading}>{Translations.reservationAddPreferencesHeading}</Text>
			<Text style={styles.addPreferencesText}>{Translations.reservationAddPreferencesText}</Text>
			<TertiaryButton
				buttonStyle={styles.addPreferencesButton}
				label={Translations.reservationAddPreferences}
				onPress={() => openInBrowser(url)}
			/>
		</View>
	) : (
		<></>
	);
}

const styles = StyleSheet.create({
	addPreferencesContainer: {
		padding: Dimens.padding20,
		backgroundColor: Colors.gray100,
	},
	addPreferencesHeading: {
		fontSize: Dimens.fontSize19,
		fontFamily: Fonts.ptSerif,
		marginBottom: Dimens.padding10,
	},
	addPreferencesText: {
		color: Colors.gray600,
		marginBottom: Dimens.padding20,
		lineHeight: Dimens.lineHeight25,
	},
	addPreferencesButton: {
		height: Dimens.size50,
	},
});

export default ReservationPreferenceCta;
